module.exports = __webpack_public_path__ + "img/logo-skeleton.392d72bf.png";